<template>
  <main id="main">
    <template v-if="$page && activity">
      <section class="section section__content --single">
        <button
          class="button --return"
          @click="$router.back()"
          :title="$t('return')"
          v-reveal="{ delay: 400 }"
        >
          <Icon id="arrow" />
          <span>{{ $t('return') }}</span>
        </button>
        <div class="activity__content-container">
          <div class="activity__content">
            <h1 class="title --main" v-reveal>{{ activity.title }}</h1>
            <p
              :class="['activity__category', color(category.color, 'activity')]"
              v-reveal="{ delay: 200 }"
            >
              {{ category.title }}
            </p>
            <ActivityDetails
              :activity="activity"
              :group-id="group"
              v-if="!mq.mdPlus"
              v-reveal="{ delay: 250 }"
            />
            <RawHtml :html="activity.description" v-reveal="{ delay: 250 }" />
          </div>
          <ActivityDetails
            :activity="activity"
            :group-id="group"
            v-if="mq.mdPlus"
            v-reveal="{ delay: 300 }"
          />
        </div>
      </section>
      <section class="section section__content --centered">
        <HeadingBlock :content="$page.cta" />
        <ul class="activity__card-group">
          <DetailedActivityCard
            :activity="featuredActivity"
            v-for="(featuredActivity, featuredActivityIndex) in featuredActivities"
            :key="featuredActivityIndex"
            v-reveal="{ delay: 50 * featuredActivityIndex + 250 }"
          />
        </ul>
        <LangRouterLink
          :to="{ name: 'activities' }"
          class="button --top --centered"
          :title="$t('activities.explore')"
          v-reveal="{ delay: 300 }"
        >
          {{ $t('activities.explore') }}
        </LangRouterLink>
      </section>
    </template>
    <Transition name="fade">
      <Loader v-if="!$page || !activity" />
    </Transition>
  </main>
</template>

<script>
import { ActivityDetails, HeadingBlock } from '@/components/blocks'
import { DetailedActivityCard } from '@/components/cards'
import { Icon, LangRouterLink, RawHtml } from '@/components/global'
import { Loader } from '@/components/small'
import { color, shuffle } from '@/helpers'
import { HasCategory } from '@/mixins'

export default {
  name: 'Activity',
  mixins: [HasCategory],
  beetPage: 'activity',
  inject: ['mq'],
  components: {
    ActivityDetails,
    DetailedActivityCard,
    HeadingBlock,
    Icon,
    LangRouterLink,
    Loader,
    RawHtml,
  },
  beforeMount() {
    const activityId = this.$store.getters.activitiesSlugMap[this.$route.params.slug]
    if (!activityId) this.$router.push({ name: 'activities' })
    if (!this.$route.query.g)
      this.$router.push({
        ...this.$route,
        query: { g: Object.keys(this.$beet.activities[activityId].groups)[0] },
      })
  },
  computed: {
    activity() {
      return this.$beet.activities[this.$store.getters.activitiesSlugMap[this.$route.params.slug]]
    },
    category() {
      return (
        this.getCategory(this.activity.category) ?? {
          color: 'pp',
          id: 0,
          title: this.$t('general'),
        }
      )
    },
    featuredActivities() {
      const activities = this.category
        ? shuffle(
            Object.entries(this.$store.state.activities.filteredByCategory)
              .filter(
                (category) => category[0] !== this.category.id.toString() && category[1].length > 0,
              )
              .map((category) => shuffle(category[1])[0]),
          ).slice(0, 2)
        : []

      return activities.length === 2
        ? activities
        : [
            ...activities,
            ...shuffle([...this.$store.state.activities.items])
              .filter((activity) => activity.id !== this.activity.id)
              .slice(0, 2 - activities.length),
          ]
    },
    group() {
      return this.$route.query.g
    },
  },
  watch: {
    activity: {
      handler() {
        if (this.activity) this.$store.dispatch('updateActivitySeo', this.activity)
      },
      immediate: true,
    },
  },
  methods: { color },
}
</script>
